/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/** @module SharedModule */

import {
    Component,
    Input,
} from '@angular/core';

import './avi-content-loading-container.component.less';

/**
 * @description Wrapper component to show spinner over another component.
 * @author Shanmukha Sarath Kondiparthi
 */
@Component({
    selector: 'avi-content-loading-container',
    templateUrl: './avi-content-loading-container.component.html',
})
export class AviContentLoadingContainerComponent {
    @Input()
    public isLoading = false;

    @Input('aviMediumSpinner')
    private set mediumSizedSpinner(size: unknown) {
        this.isSpinnerMedium = size === '' || Boolean(size) || null;
    }

    @Input('aviSmallSpinner')
    private set smallSizedSpinner(size: unknown) {
        this.isSpinnerSmall = size === '' || Boolean(size) || null;
    }

    public isSpinnerMedium: true | null;

    public isSpinnerSmall: true | null;
}
